import React from "react";
const contexto = React.createContext();
var ProveedorContexto = contexto.Provider;
var ConsumerContexto = contexto.Consumer;
export {
    ProveedorContexto,
    ConsumerContexto
};
export default contexto;